import {
  Box,
  Button,
  Column,
  Columns,
  Control,
  Field,
  Input,
  Modal,
  Pagination,
  Section,
  Table,
  Title,
} from "@allxsmith/bestax-bulma";

import React, { useState } from "react";
import { useSelector } from "react-redux";
import {getWorkLookupData} from "../../state/selectors";
import {useWorkLookupsData} from "../../hooks/useWorkLookupsData";
import WorkSearchModalRow from "./WorkSearchModalRow";
import PaginationWrapper from "../Utils/PaginationWrapper";

export default function WorkSearchModal({
  modalOpen,
  currentSearch,
  searchText,
  selectWork,
  workIndex,
  setModalState,
  supplier
}) {
  const [page, setPage] = useState(1);
  let params = {
    page: page,
    search: currentSearch,
    // view: "with_number",
    work_lookup_stock: true
  };

  const complete = useWorkLookupsData(params, 1, !modalOpen);
  const data = useSelector(getWorkLookupData);

  const setModalOpen = val => {
    setModalState({
      modalOpen: val,
      currentSearch,
      searchText,
      workIndex,
    });
  };

  const setSearchText = val => {
    setModalState({
      searchText: val,
      currentSearch,
      modalOpen,
      workIndex,
    });
  };

  const setCurrentSearch = val => {
    setModalState({
      currentSearch: val,
      searchText,
      modalOpen,
      workIndex,
    });
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <Modal closeOnBlur active={modalOpen} onClose={() => setModalOpen(false)}>
      <Modal.Content className="work-search-content wider-modal">
        <Section style={{ backgroundColor: "grey" }}>
          <Box>
            <Title>Works Selector</Title>
            <Columns isMultiline>
              <Column>
                <label className="label">Work Search</label>
                <Field className="has-addons">
                  <Control>
                    <Input
                      onChange={e => {
                        setSearchText(e.target.value);
                      }}
                      onKeyPress={e => (e.key === 'Enter' || e.keyCode === 13) && setCurrentSearch(searchText)}
                      data-testid="work-search"
                      name="search_text"
                      type="text"
                      placeholder="Search"
                      value={searchText}
                    />
                  </Control>
                  <Control>
                    <Button
                      data-testid="search-button"
                      color="success"
                      onClick={() => {
                        setCurrentSearch(searchText);
                      }}
                    >
                      Search
                    </Button>
                  </Control>
                  <Control>
                    <Button
                      color="warning"
                      onClick={() => {
                        setModalState({
                          modalOpen,
                          workIndex,
                          currentSearch: "",
                          searchText: ""
                        });
                      }}
                    >
                      Clear
                    </Button>
                  </Control>
                </Field>
              </Column>
            </Columns>
          </Box>
          <Box>
            <Table>
              <thead>
                <tr>
                  <th>Work Description</th>
                  <th>Labour Hours</th>
                  <th>Labour Cost</th>
                  <th>Customer Labour Charge</th>
                  <th>Supplier</th>
                  <th>Number of Parts</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {(complete && data) &&
                  data.results.map(work => (
                    <WorkSearchModalRow
                      work={work}
                      workIndex={workIndex}
                      selectWork={selectWork}
                    />
                  ))}
              </tbody>
            </Table>
            <Columns>
              <Column>
                <Button
                  color={"info"}
                  onClick={() => setModalOpen(false)}
                >
                  Close
                </Button>
              </Column>
            </Columns>
            <PaginationWrapper
              setPage={setPage}
              page={page}
              dataCount={Math.ceil(data ? data.count / 25 : 0)}
            />
          </Box>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
